import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileImagePlaceholder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 410 410",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 410,
			height: 410,
			rx: 20,
			fill: "transparent"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 125,
			y: 105,
			width: 160,
			height: 120,
			rx: 14,
			fill: "#EEF2F7"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 245,
			cy: 135,
			r: 11,
			fill: "#CBD5E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M140 205L180 165L210 192L235 175L270 215H140V205Z",
			fill: "#CBD5E1"
		})
	]
});
export { SvgFileImagePlaceholder as ReactComponent };
